import LeadIcon from '@/common/icons/LeadIcon';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMasterApprenticesStatStore } from '../../store';

interface Props {
  title: string;
  isBack?: boolean;
  isResponsible?: boolean;
  mastersTotal?: number;
  apprenticesTotal?: number;
  isRepublic?: boolean;
  isEmployees?: boolean;
}

export const TeacherStudentHeader: FC<Props> = ({
  title,
  isBack = true,
  isResponsible = true,
  mastersTotal = 0,
  apprenticesTotal = 0,
  isRepublic = false,
  isEmployees = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    masterApprenticesRegionResponse,
    masterApprenticesRepublicResponse,
    masterApprenticesDistrictResponse,
  } = useMasterApprenticesStatStore();

  const metaCachedAt = isRepublic
    ? masterApprenticesRepublicResponse?.meta?.cached_at
    : isEmployees
      ? masterApprenticesDistrictResponse?.meta?.cached_at
      : masterApprenticesRegionResponse?.meta?.cached_at;

  return (
    <div className="py-2.5 flex justify-between items-center w-full">
      <div className="flex items-center gap-5">
        {isBack && (
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="p-[10px] h-[40px]"
          >
            <LeadIcon />
          </Button>
        )}
        <div className="flex flex-col gap-4">
          <p className="text-[24px] leading-7 text-midnight-default font-semibold">
            {title}
          </p>
          {metaCachedAt && (
            <p className="text-sm text-gray-500 font-medium">
              {t('data.actual.on', {
                date: format(new Date(metaCachedAt), 'yyyy-MM-dd HH:mm'),
              })}
            </p>
          )}
        </div>
      </div>
      {isResponsible && (
        <div className="flex items-center gap-2 mt-2">
          <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
            <div className="flex flex-col items-start justify-between">
              <span className="text-[14px] text-gray-phantom">
                Ustozlar soni
              </span>
              <span className="text-[24px] font-bold text-dark-blue-400">
                {mastersTotal.toLocaleString()}
              </span>
            </div>
          </div>
          <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
            <div className="flex flex-col items-start justify-between">
              <span className="text-[14px] text-gray-phantom">
                Shogirdlar soni
              </span>
              <span className="text-[24px] font-bold text-dark-blue-300">
                {apprenticesTotal.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
